import utils from "../../../utils";

// Guarda las últimas secciones (formulario/dashboard) visitadas, por proyecto y centro, en una sola
// clave de localStorage: [{project, hospital, sections: ["form/23", ...]}], la más reciente primero.
// Solo se guarda la ruta relativa (p.ej. "form/23"): nunca datos ni ids de paciente.
const STORAGE_KEY = 'home.recent';
const MAX_PROJECTS = 5;
const MAX_SECTIONS = 8;
const IGNORED = ['home', 'search', 'selector'];

const readAll = () => {
	try {
		const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
		return Array.isArray(stored) ? stored : [];
	} catch (e) {
		return [];
	}
};

// El formato anterior usaba una clave por proyecto y centro ("home.recent.<proyecto>.<centro>")
const removeLegacyKeys = () => {
	try {
		Object.keys(localStorage)
			.filter(key => key.startsWith(`${STORAGE_KEY}.`))
			.forEach(key => localStorage.removeItem(key));
	} catch (e) {
		// sin acceso a localStorage no hay nada que limpiar
	}
};
removeLegacyKeys();

export const getRecentSections = (project, hospital) => {
	const entry = readAll().find(item => item.project === project && item.hospital === hospital);
	return entry ? entry.sections : [];
};

export const trackSectionVisit = (location) => {
	const project = utils.getProjectLocation(location);
	const hospital = utils.getHospitalLocation(location);
	const root = utils.getInitRootProject(location);
	if (!project || !hospital || !location.pathname.startsWith(root + '/'))
		return;

	const section = location.pathname.slice(root.length + 1).replace(/\/$/, '');
	if (!section || IGNORED.includes(section.split('/')[0]))
		return;

	const all = readAll();
	const current = all.find(item => item.project === project && item.hospital === hospital);
	const sections = [section, ...(current ? current.sections : []).filter(url => url !== section)].slice(0, MAX_SECTIONS);
	const others = all.filter(item => item !== current);
	try {
		// El proyecto visitado pasa al principio; se descartan los más antiguos a partir del quinto
		localStorage.setItem(STORAGE_KEY, JSON.stringify([{project, hospital, sections}, ...others].slice(0, MAX_PROJECTS)));
	} catch (e) {
		// localStorage no disponible: la home simplemente no muestra recientes
	}
};
